import React from "react";
import { useSettings } from "../context/SettingsContext";

export default function PolicyPage({ type }) {
  const { settings } = useSettings();
  const brand = settings.brandName;
  const today = new Date().toLocaleDateString("he-IL");

  const content = {
    privacy: {
      title: "מדיניות פרטיות",
      sections: [
        ["כללי", `מדיניות פרטיות זו מתארת כיצד ${brand} ("האתר", "אנחנו") אוסף, משתמש ושומר מידע אודות המשתמשים הגולשים באתר. השימוש באתר מהווה הסכמה לתנאי מדיניות זו.`],
        ["איזה מידע נאסף", "אנו עשויים לאסוף פרטים שתמסור מרצונך, כגון שם, מספר טלפון וכתובת דוא\"ל בעת יצירת קשר או הרשמה לרשימת התפוצה, וכן נתוני גלישה אנונימיים (כגון דפים שנצפו) לצורכי שיפור השירות."],
        ["שימוש במידע", "המידע משמש למענה לפניות, לתיאום הזמנות שמתבצעות דרך וואטסאפ, לשליחת עדכונים ומבצעים (בכפוף להסכמתך), ולשיפור חוויית המשתמש באתר."],
        ["מסירת מידע לצד שלישי", "איננו מוכרים או משכירים את פרטיך לצדדים שלישיים. מידע עשוי להימסר רק כאשר הדבר נדרש על פי דין או לצורך אספקת השירות (למשל שירותי דיוור)."],
        ["אבטחת מידע", "אנו נוקטים אמצעים סבירים לשמירה על אבטחת המידע. עם זאת, לא ניתן להבטיח הגנה מוחלטת, והשימוש באתר נעשה על אחריות המשתמש."],
        ["זכויותיך", "באפשרותך לפנות אלינו בכל עת בבקשה לעיין במידע שנשמר אודותיך, לתקנו או למחקו, באמצעות פרטי הקשר המופיעים מטה."],
        ["יצירת קשר", `בכל שאלה בנוגע למדיניות הפרטיות ניתן לפנות אלינו בדוא\"ל ${settings.email} או בטלפון ${settings.whatsappDisplay}.`],
      ],
    },
    terms: {
      title: "תקנון ותנאי שימוש",
      sections: [
        ["כללי", `ברוכים הבאים ל-${brand}. השימוש באתר ובתכניו כפוף לתנאים המפורטים בתקנון זה. גלישה באתר מהווה הסכמה מלאה לתנאים אלה.`],
        ["המוצרים והמחירים", "התמונות והמחירים באתר מוצגים לצורכי המחשה. אנו עושים מאמץ להציג מידע מדויק, אך ייתכנו טעויות או שינויים במלאי ובמחירים ללא הודעה מוקדמת."],
        ["ביצוע הזמנות", "האתר אינו כולל מערכת סליקה. הזמנת מוצר מתבצעת באמצעות פנייה ישירה בוואטסאפ, ותיאום אספקה ותשלום ייעשו מול נציג המותג. ההזמנה כפופה לאישור זמינות המלאי."],
        ["קניין רוחני", `כל התכנים באתר, לרבות לוגו, טקסטים ותמונות, הם רכוש ${brand} ואין לעשות בהם שימוש ללא אישור מראש ובכתב.`],
        ["אחריות", "המותג לא יישא באחריות לכל נזק ישיר או עקיף הנובע מהשימוש באתר. השירות ניתן כפי שהוא (As Is)."],
        ["שינויים בתקנון", "אנו רשאים לעדכן תקנון זה מעת לעת. הנוסח המעודכן יחייב מרגע פרסומו באתר."],
        ["יצירת קשר", `לשאלות ניתן לפנות בדוא\"ל ${settings.email} או בטלפון ${settings.whatsappDisplay}.`],
      ],
    },
    shipping: {
      title: "מדיניות הזמנות, משלוחים והחזרות",
      sections: [
        ["אופן ביצוע הזמנה", `אתר ${brand} הוא אתר תצוגה (קטלוג). באתר לא מתבצעים תשלום או רכישה ישירה. בלחיצה על "הזמנה בוואטסאפ" אצל מוצר, נפתחת שיחת וואטסאפ עם פרטי המוצר, וההזמנה, התשלום והאספקה מתואמים ישירות מול נציג/ת המותג.`],
        ["זמינות מלאי ומחירים", "הצגת מוצר באתר אינה מהווה התחייבות למלאי. זמינות המוצר, המידה והמחיר העדכני יאושרו מול הלקוח/ה בעת התיאום בוואטסאפ."],
        ["אספקה ותשלום", "פרטי האספקה (איסוף עצמי / משלוח), זמני האספקה, עלות המשלוח ואמצעי התשלום יסוכמו באופן אישי מול הלקוח/ה במהלך השיחה בוואטסאפ, בהתאם לאזור ולסוג ההזמנה."],
        ["החלפות והחזרות", "החלפה או החזרה של מוצר תתבצע בתיאום מול נציג/ת המותג בוואטסאפ, ובהתאם להוראות חוק הגנת הצרכן והתקנות מכוחו, כל עוד לא נעשה במוצר שימוש, באריזתו המקורית ובצירוף הוכחת קנייה."],
        ["מוצר פגום או שגוי", "במקרה של מוצר פגום או שגוי, אנא פנו אלינו בהקדם בוואטסאפ ונדאג לפתרון מהיר (החלפה או החזר), בהתאם לדין."],
        ["יצירת קשר", `לכל שאלה, תיאום הזמנה או החלפה/החזרה ניתן לפנות אלינו בוואטסאפ ${settings.whatsappDisplay} או בדוא\"ל ${settings.email}.`],
      ],
    },
    accessibility: {
      title: "הצהרת נגישות",
      sections: [
        ["מחויבות לנגישות", `אתר ${brand} שואף לאפשר לכלל הציבור, לרבות אנשים עם מוגבלות, לגלוש בו בצורה נוחה ושוויונית, מתוך מחויבות לעקרונות שוויון ההזדמנויות.`],
        ["התאמות הנגישות באתר", "באתר מוטמע רכיב נגישות (כפתור הנגישות הצף) המאפשר, בין היתר: הגדלת והקטנת גודל הטקסט, מצב ניגודיות גבוהה, ניגודיות הפוכה, תצוגת גווני אפור, הדגשת קישורים, מעבר לגופן קריא ועצירת אנימציות. ההגדרות נשמרות בדפדפן המשתמש."],
        ["תאימות", "האתר נבנה תוך מאמץ לעמוד בהנחיות הנגישות המקובלות (WCAG 2.1 ברמה AA) ובהתאם לתקן הישראלי ת\"י 5568, ונתמך בדפדפנים המודרניים ובמכשירים ניידים."],
        ["הסתייגות", "ייתכנו דפים או רכיבים שטרם הונגשו במלואם. אנו פועלים באופן שוטף לשיפור הנגישות. אם נתקלת בקושי, נשמח שתעדכנו אותנו ונטפל בכך בהקדם."],
        ["פניות בנושא נגישות", `ניתן לפנות לרכז הנגישות שלנו בדוא\"ל ${settings.email} או בטלפון ${settings.whatsappDisplay}, ונשתדל להיענות בהקדם.`],
      ],
    },
  };

  const data = content[type] || content.privacy;

  return (
    <div className="fade-up mx-auto max-w-3xl px-4 md:px-8 py-16" dir="rtl">
      <p className="text-xs tracking-[0.3em] text-neutral-400 text-center">{brand}</p>
      <h1 className="font-display text-3xl md:text-4xl tracking-wide text-center mt-3">{data.title}</h1>
      <p className="text-center text-xs text-neutral-400 mt-3">עודכן לאחרונה: {today}</p>

      <div className="mt-10 space-y-7">
        {data.sections.map(([heading, body], i) => (
          <section key={i}>
            <h2 className="text-lg font-semibold text-neutral-900 mb-2">{heading}</h2>
            <p className="text-sm leading-relaxed text-neutral-600">{body}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
